import React from "react";
import ReceiptCancelModal from "../ReceiptCancelModal";

const ActionModal = (props) => {
  return <ReceiptCancelModal {...props} />;
};

export default ActionModal;
